import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SignIn } from '@clerk/clerk-react';
import { Box, Typography, Container } from '@mui/material';

function SignInPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Helmet>
        <title>Σύνδεση | Majestify</title>
        <meta name="description" content="Σύνδεσε στο Majestify για να διαχειριστείς το προσωπικό και τα οικονομικά της επιχείρησής σου." />
      </Helmet>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h3" sx={{ color: 'white', fontWeight: 'bold', mb: 1 }}>
            🌴 Palmera
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            Διαχείριση Καταστήματος
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <SignIn 
            routing="path" 
            path="/sign-in"
            signUpUrl="/sign-up"
            afterSignInUrl="/"
          />
        </Box>
      </Container>
    </Box>
  );
}

export default SignInPage;

